import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { ChevronIcon } from "../chevronIcon";
import { getMonthsNames } from "../utils";
import { Props } from "./types";
import { getWeekRows, getMonday, getDaysTexts } from "./utils";
import styles from "./styles.scss";

function Days({
  date,
  cursor,
  editCursor,
  editWeek,
  switchViews,
  ...props
}: Props) {
  const { t } = useTranslation();
  const months = getMonthsNames(t);
  const daysNames = getDaysTexts(t);
  const rows = getWeekRows({
    year: cursor.getFullYear(),
    month: cursor.getMonth(),
    day: cursor.getDate(),
  });

  const isSelectedWeek = (monday: Date) =>
    date.year === monday.getFullYear() &&
    date.month === monday.getMonth() &&
    date.day === monday.getDate();

  return (
    <div className={styles.calendar}>
      <div className={styles.heading}>
        <div
          className={styles.iconBox}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ month: cursor.getMonth() - 1, day: 10 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.leftIcon)} />
        </div>
        <h3 className={styles.title} onClick={() => switchViews("months")}>
          {months[cursor.getMonth()]} {cursor.getFullYear()}
        </h3>
        <div
          className={styles.iconBox}
          onClick={(e) => {
            e.stopPropagation();
            editCursor({ month: cursor.getMonth() + 1, day: 10 });
          }}
        >
          <ChevronIcon className={classNames(styles.icon, styles.rightIcon)} />
        </div>
      </div>
      <div className={styles.grid}>
        <div className={styles.headerRow}>
          {daysNames.map((name, index) => (
            <div key={index} className={styles.dayName}>
              {name.slice(0, 3)}
            </div>
          ))}
        </div>
        {rows.map((row, rowIndex) => {
          const monday = getMonday(
            cursor.getFullYear(),
            cursor.getMonth(),
            row,
          );
          const selected = isSelectedWeek(monday);

          return (
            <div
              key={rowIndex}
              className={classNames(styles.weekRow, {
                [styles.selectedWeek]: selected,
              })}
              onClick={(e) => {
                e.stopPropagation();
                editWeek({
                  year: monday.getFullYear(),
                  month: monday.getMonth(),
                  day: monday.getDate(),
                });
              }}
            >
              {row.map((cell, cellIndex) => (
                <div
                  key={cellIndex}
                  className={classNames(styles.day, {
                    [styles.otherMonth]: !cell.isCurrentMonth,
                  })}
                >
                  {cell.day}
                </div>
              ))}
            </div>
          );
        })}
      </div>
      {!!props.today && (
        <div className={styles.footer} onClick={props.today}>
          <div className={styles.button}>
            <p>{t("calendar.today")}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export { Days };
